import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapRolesToContentTableItems(
	roles: RoleResponse[]
): ContentTableItem[] {
	return roles.map((role) => ({
		id: role.id,
		name: role.name,
		isActive: true,
		data: {
			permissionCount: role.permissions.length
		}
	}));
}
